import * as React from 'react';
import './CenterComponent.css';

interface Props {
    children: JSX.Element;
    header?: JSX.Element[];
}

interface State {
}

export class CenterContainer extends React.Component {

    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {
        };
    }

    /**
     * le rendu de la classe CenterContainer
     * @returns {JSX.Element}
     */
    render() {
        return (
            <div
                className="row align-items-center justify-content-center"
                style={{ height: '100%' }}
            >
                <div
                    className="col-lg-4 col-md-6 col-sm-8 CenterContainer "
                >
                    <div className="CenterComponentHeader row">
                        <a href="http://www.chorinitia-danse.fr/" className="col-12">
                            <h1 className="text-center">
                                <img
                                    src={require('./chorinitia.svg')}
                                    alt="Chor'initia danse"
                                />
                            </h1>
                        </a>
                        {this.props.header}
                    </div>
                    <hr className="row" />
                    <div className="CenterComponentBoddy row">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );

    }
}


// WEBPACK FOOTER //
// ./src/components/LoginPage/internalComponents/CenterContainer.tsx